import componentNotifier from '../../../services/wss/ComponentNotifier';

const CHANNEL = 'JAutoComplete';

/**
 * Pub/sub bridge for JAutoComplete instances.
 * Uses ComponentNotifier so no new infrastructure is needed.
 *
 * Events fired:
 *   target = id, data = { event: 'selected', value } — item selected
 *   target = id, data = { event: 'enterPressed', value } — Enter key pressed
 *   target = id, data = { event: 'cleared' } — × cleared
 *
 * Usage — subscribe:
 *   const unsub = JAutoCompleteNotifier.subscribe('service-selector', ({ event, value }) => { ... });
 */
const JAutoCompleteNotifier = {
    /**
     * @param {string} id
     * @param {'selected'|'enterPressed'|'cleared'} event
     * @param {string} [value]
     */
    notify: (id, event, value = '') => {
        componentNotifier.notify(CHANNEL, id, { event, value });
    },

    /**
     * @param {string} id
     * @param {Function} cb - receives { event, value }
     * @returns {Function} unsubscribe
     */
    subscribe: (id, cb) => {
        return componentNotifier.subscribe(CHANNEL, (e) => {
            if (e.target !== id) return;
            cb(e.data);
        });
    },
};

export default JAutoCompleteNotifier;
